module.exports = __webpack_public_path__ + "img/five_stars_top.841a7b9f.jpg";